import React from 'react'
import { CustomContentModal } from '../../../../components/CustomContentModal'
import { ServiceAccount } from '../../../../apis/types'
import CurrentInvoiceSummary from './CurrentInvoiceSummary'
import PostPaymentForm from './PostPaymentForm'

interface PostTenantPaymentModalProps {
  isOpen: boolean
  onClose: () => void
  serviceAccount: ServiceAccount
}

const PostTenantPaymentModal: React.FC<PostTenantPaymentModalProps> = ({ isOpen, onClose, serviceAccount }) => {
  if (!isOpen) return null

  return (
    <CustomContentModal isOpen={isOpen} onClose={onClose}>
      <div className="w-full max-w-3xl rounded-lg bg-white p-6 text-left shadow-xl dark:bg-slate-800">
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">Post tenant payment</h3>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Post a payment against the current invoice for this account.
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-[minmax(0,14rem)_minmax(0,1fr)]">
          <CurrentInvoiceSummary serviceAccount={serviceAccount} embedded />
          <div className="min-w-0">
            {serviceAccount.accountManagers.length > 0 ? (
              <PostPaymentForm serviceAccount={serviceAccount} onSuccess={onClose} onCancel={onClose} />
            ) : (
              <p className="text-gray-500 dark:text-gray-400">
                Please add an account manager to this service account before posting a payment.
              </p>
            )}
          </div>
        </div>
      </div>
    </CustomContentModal>
  )
}

export default PostTenantPaymentModal
